import React from 'react';

interface StatusLabelProps {
  status: string;
}

const getStatusDetails = (status: string) => {
  switch (status) {
    case 'New':
      return {
        label: 'New',
        color: 'bg-indigo-500',
        textColor: 'text-indigo-700',
      };
    case 'rejected':
      return {
        label: 'Rejected',
        color: 'bg-rose-500',
        textColor: 'text-rose-700',
      };
    case 'candidate rejected':
      return {
        label: 'Candidate Rejected',
        color: 'bg-amber-500',
        textColor: 'text-amber-700',
      };
    case 'failed':
      return {
        label: 'Failed',
        color: 'bg-red-600',
        textColor: 'text-red-800',
      };
    case 'Invited':
      return {
        label: 'Invited',
        color: 'bg-sky-400',
        textColor: 'text-sky-600',
      };
    case 'Confirmed':
      return {
        label: 'Confirmed',
        color: 'bg-emerald-500',
        textColor: 'text-emerald-700',
      };
    case 'Completed':
      return {
        label: 'Completed',
        color: 'bg-blue-500',
        textColor: 'text-blue-700',
      };
    case 'Scheduled':
      return {
        label: 'Scheduled',
        color: 'bg-violet-500',
        textColor: 'text-violet-700',
      };
    default:
      return {
        label: 'Unknown',
        color: 'bg-slate-300',
        textColor: 'text-slate-600',
      };
  }
};

const StatusLabel: React.FC<StatusLabelProps> = ({ status = 'unknown' }) => {
  if (!status) {
    return <div>Invalid status</div>; // Optionally handle invalid status
  }

  const { label, color, textColor } = getStatusDetails(status);

  return (
    <div className='flex items-center gap-2'>
      <span
          className={`w-2.5 h-2.5 rounded-full ${color} ring-2 ring-offset-2 ring-offset-white ring-opacity-30 ${color.replace(
            'bg-',
            'ring-',
          )}`}
      />
      <span className={`${textColor} font-medium text-sm`}>{ label }</span>
    </div>
  );
};

export default StatusLabel;
